// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 1989) return "static/css/1989.dcbf0c0b252c18316905.css";
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"65a8d47ffc05ff4a9c36","1412":"83971b4df2c901ec0bdb","1904":"65a8d47ffc05ff4a9c36","4983":"65a8d47ffc05ff4a9c36","6432":"65a8d47ffc05ff4a9c36"}[chunkId] + ".chunk.css";
};